import '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import { NewsArticleGetModuleFactory } from '../../endpoints/news/article/get.module.js';
import { NewsArticleSearchByTextModuleFactory } from '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import { BasicLanguageListModuleFactory } from '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import { NewsListByMediaKindModuleFactory } from '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { NewsArticleSearchByTextSubscriptionModuleFactory } from '../../subscriptions/news/article/searchByText.module.js';
import { NewsListByMediaKindSubscriptionModuleFactory } from '../../subscriptions/news/article/listByMediaKind.module.js';
import '../../subscriptions/prices/get.module.js';
import '../../subscriptions/prices/bidAsk/get.module.js';
import '../../subscriptions/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../subscriptions/alerting/prices/basic/alert/list.module.js';
import '../../subscriptions/prices/orderbook/aggregated/get.module.js';
import { convertMdg2DateTimeResponse, getArrayValue, getUrl, getEndpointOptions, getLanguage } from '../../helpers/common.js';
import set from 'lodash.set';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';

var _a, _b, _c, _d, _e, _f;
class NewsListStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.defaultPushOption = true;
    this.defaultWordsPerMinute = 225;
    this.isPushEnabled = (_c = (_b = (_a = this.options) == null ? void 0 : _a.push) == null ? void 0 : _b.enabled) != null ? _c : this.defaultPushOption;
    this.wordsPerMinute = (_f = (_e = (_d = this.options) == null ? void 0 : _d.preview) == null ? void 0 : _e.wordsPerMinute) != null ? _f : this.defaultWordsPerMinute;
    this.defaultLanguage = "en";
    this.defaultLanguageId = 1;
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload),
      meta: this.getResponseMeta(payload)
    };
  }
  getResponseData(payload) {
    var _a2;
    const criteriaCopy = structuredClone(payload.criteria);
    const listData = this.isListByMediaKindRequest(criteriaCopy) ? this.getNewsListByMediaKindByData(criteriaCopy, payload) : this.getNewsArticleSearchByTextByData(criteriaCopy, payload);
    return (_a2 = listData == null ? void 0 : listData.map((newsArticle) => this.getResponseItem(payload, newsArticle))) != null ? _a2 : null;
  }
  getNewsArticleSearchByTextByData(criteria, payload) {
    return !payload.activePageCursor && this.isPushEnabled ? this.getNewsArticleSearchByTextSubscriptionData(criteria, payload) : this.getNewsArticleSearchByTextData(criteria, payload);
  }
  getNewsListByMediaKindByData(criteria, payload) {
    return !payload.activePageCursor && this.isPushEnabled ? this.getNewsListByMediaKindSubscriptionData(criteria, payload) : this.getNewsListByMediaKindData(criteria, payload);
  }
  getResponseItem(payload, newsArticle) {
    var _a2, _b2, _c2;
    try {
      const newsArticleData = this.getNewsArticleGetData(payload, newsArticle);
      const id = this.getNewsArticleCode(newsArticle);
      return {
        id,
        headline: (_a2 = newsArticle.headline) != null ? _a2 : null,
        summary: (_b2 = newsArticleData == null ? void 0 : newsArticleData.summary) != null ? _b2 : null,
        time: convertMdg2DateTimeResponse(newsArticle.time),
        distributor: (_c2 = newsArticleData == null ? void 0 : newsArticleData.distributor.name) != null ? _c2 : null,
        types: newsArticleData ? getArrayValue(newsArticleData.types.map((type) => type.name)) : null,
        estimatedReadingTime: this.getEstimatedReadingTime(newsArticleData),
        media: this.getNewsArticleMedia(newsArticleData)
      };
    } catch (error) {
      return this.getEmptyResponseItem();
    }
  }
  getNewsArticleCode(newsArticle) {
    if (!newsArticle.code) {
      throw new Error("Could not get news article code");
    }
    return newsArticle.code;
  }
  getNewsArticleGetData(payload, newsArticle) {
    var _a2;
    try {
      const code = this.getNewsArticleCode(newsArticle);
      const request = this.getNewsArticleGetRequest(code);
      const response = this.getEndpoints().newsArticleGet.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (error) {
      return null;
    }
  }
  getEstimatedReadingTime(newsArticleData) {
    if (!(newsArticleData == null ? void 0 : newsArticleData.body)) {
      return null;
    }
    const wordsLength = newsArticleData.body.trim().split(/\s+/).length;
    return Math.ceil(wordsLength / this.wordsPerMinute);
  }
  getNewsArticleMedia(newsArticleData) {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g;
    const audio = newsArticleData == null ? void 0 : newsArticleData.media.find((item) => {
      var _a3;
      return (_a3 = item.mimeType) == null ? void 0 : _a3.startsWith("audio");
    });
    const video = newsArticleData == null ? void 0 : newsArticleData.media.find((item) => {
      var _a3;
      return (_a3 = item.mimeType) == null ? void 0 : _a3.startsWith("video");
    });
    const document = newsArticleData == null ? void 0 : newsArticleData.media.find((item) => {
      var _a3;
      return (_a3 = item.mimeType) == null ? void 0 : _a3.startsWith("document");
    });
    const image = newsArticleData == null ? void 0 : newsArticleData.media.find((item) => {
      var _a3;
      return (_a3 = item.mimeType) == null ? void 0 : _a3.startsWith("image");
    });
    if (this.mediaAreEmpty(audio, video, document, image)) {
      return null;
    }
    const media = (_b2 = (_a2 = audio != null ? audio : video) != null ? _a2 : document) != null ? _b2 : image;
    return {
      type: this.getNewsArticleMediaType(audio, video, document, image),
      mimeType: (_c2 = media == null ? void 0 : media.mimeType) != null ? _c2 : null,
      url: getUrl((_d2 = media == null ? void 0 : media.url) != null ? _d2 : null, this.options),
      preview: {
        url: getUrl((_e2 = image == null ? void 0 : image.url) != null ? _e2 : null, this.options),
        alt: (_g = (_f2 = image == null ? void 0 : image.alternativeText) != null ? _f2 : image == null ? void 0 : image.caption) != null ? _g : null
      }
    };
  }
  mediaAreEmpty(audio, video, document, image) {
    return audio === void 0 && video === void 0 && document === void 0 && image === void 0;
  }
  getNewsArticleMediaType(audio, video, document, image) {
    if (audio !== void 0) {
      return "audio";
    }
    if (video !== void 0) {
      return "video";
    }
    if (document !== void 0) {
      return "document";
    }
    return "image";
  }
  getEmptyResponseItem() {
    return {
      id: null,
      headline: null,
      summary: null,
      time: null,
      distributor: null,
      types: null,
      estimatedReadingTime: null,
      media: null
    };
  }
  getResponseMeta(payload) {
    var _a2, _b2, _c2, _d2;
    const criteriaCopy = structuredClone(payload.criteria);
    const listMeta = this.isListByMediaKindRequest(criteriaCopy) ? this.getNewsListByMediaKindByMeta(criteriaCopy, payload) : this.getNewsArticleSearchByTextByMeta(criteriaCopy, payload);
    return {
      pagination: {
        next: (_b2 = (_a2 = listMeta == null ? void 0 : listMeta.pagination) == null ? void 0 : _a2.next) != null ? _b2 : null,
        previous: (_d2 = (_c2 = listMeta == null ? void 0 : listMeta.pagination) == null ? void 0 : _c2.previous) != null ? _d2 : null
      }
    };
  }
  getNewsArticleSearchByTextByMeta(criteria, payload) {
    return !payload.activePageCursor && this.isPushEnabled ? this.getNewsArticleSearchByTextSubscriptionMeta(criteria, payload) : this.getNewsArticleSearchByTextMeta(criteria, payload);
  }
  getNewsListByMediaKindByMeta(criteria, payload) {
    return !payload.activePageCursor && this.isPushEnabled ? this.getNewsListByMediaKindSubscriptionMeta(criteria, payload) : this.getNewsListByMediaKindMeta(criteria, payload);
  }
  async updateComponentsInputs(payload) {
    const criteriaCopy = structuredClone(payload.criteria);
    let isResponseSuccessful = true;
    try {
      if (this.isListByMediaKindRequest(criteriaCopy)) {
        this.updateListByMediaKind(criteriaCopy, payload);
        return true;
      }
      this.updateSearchByText(criteriaCopy, payload);
    } catch (error) {
      isResponseSuccessful = false;
      this.logger.error(error);
    }
    return Promise.resolve(isResponseSuccessful);
  }
  isListByMediaKindRequest(criteria) {
    return criteria !== void 0 && Object.prototype.hasOwnProperty.call(criteria, "ids");
  }
  async updateListByMediaKind(criteria, payload) {
    const cursor = payload.activePageCursor;
    await this.updateBasicLanguageList(payload);
    if (cursor === null && this.isPushEnabled) {
      const observable = await this.getNewsListByMediaKindObservable(criteria, payload);
      observable.subscribe((result) => {
        const resultData = { data: result.response.data, meta: result.response.meta };
        this.updateSubscriptionData(resultData, payload);
      });
      return [];
    }
    await this.updateNewsListByMediaKind(criteria, payload);
    const newsArticleSearchByTextData = this.getNewsListByMediaKindData(criteria, payload);
    return Promise.all((newsArticleSearchByTextData != null ? newsArticleSearchByTextData : []).map(async (newsArticle) => this.updateNewsArticleGet(payload, newsArticle)));
  }
  async updateSearchByText(criteria, payload) {
    const cursor = payload.activePageCursor;
    await this.updateBasicLanguageList(payload);
    if (cursor === null && this.isPushEnabled) {
      const observable = await this.getNewsArticleSearchByTextSubscriptionObservable(criteria, payload);
      observable.subscribe((result) => {
        const resultData = { data: result.response.data, meta: result.response.meta };
        this.updateSubscriptionData(resultData, payload);
      });
      return [];
    }
    await this.updateNewsArticleSearchByText(criteria, payload);
    const newsArticleSearchByTextData = this.getNewsArticleSearchByTextData(criteria, payload);
    return Promise.all((newsArticleSearchByTextData != null ? newsArticleSearchByTextData : []).map(async (newsArticle) => this.updateNewsArticleGet(payload, newsArticle)));
  }
  async updateSubscriptionData(resultData, payload) {
    return Promise.all(
      resultData.data.map(async (newsArticle) => {
        return this.updateNewsArticleGet(payload, newsArticle);
      })
    );
  }
  async cleanUp(payload) {
    let isResponseSuccessful = true;
    try {
      if (this.isListByMediaKindRequest(payload.criteria)) {
        await this.removeNewsListByMediaKindSubscription(payload.criteria, payload);
        return true;
      }
      await this.removeNewsArticleSearchByTextSubscription(payload.criteria, payload);
    } catch (e) {
      isResponseSuccessful = false;
      this.logger.error(e);
    }
    return isResponseSuccessful;
  }
  getEndpoints() {
    var _a2;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      this.endpoints = {
        newsArticleSearchByText: this.getModuleEntity(NewsArticleSearchByTextModuleFactory, getEndpointOptions(endpointConfiguration, "newsArticleSearchByText")),
        newsArticleSearchByTextSubscription: this.getModuleEntity(
          NewsArticleSearchByTextSubscriptionModuleFactory,
          getEndpointOptions(endpointConfiguration, "newsArticleSearchByTextSubscription")
        ),
        newsListByMediaKind: this.getModuleEntity(NewsListByMediaKindModuleFactory, getEndpointOptions(endpointConfiguration, "newsListByMediaKind")),
        newsListByMediaKindSubscription: this.getModuleEntity(
          NewsListByMediaKindSubscriptionModuleFactory,
          getEndpointOptions(endpointConfiguration, "newsListByMediaKindSubscription")
        ),
        newsArticleGet: this.getModuleEntity(NewsArticleGetModuleFactory, getEndpointOptions(endpointConfiguration, "newsArticleGet")),
        basicLanguageList: this.getModuleEntity(BasicLanguageListModuleFactory, getEndpointOptions(endpointConfiguration, "basicLanguageList"))
      };
    }
    return this.endpoints;
  }
  getNewsArticleSearchByTextRequest(criteria, payload) {
    var _a2;
    return {
      data: this.getNewsArticleSearchByTextRequestCriteria(criteria, payload),
      meta: {
        pagination: {
          limit: payload.itemsPerPage,
          cursor: (_a2 = payload.activePageCursor) != null ? _a2 : void 0
        }
      }
    };
  }
  getNewsArticleSearchByTextRequestCriteria(criteria, payload) {
    if (!(criteria == null ? void 0 : criteria.criteria) || criteria.criteria.length === 0) {
      return this.getNewsArticleSearchByTextDefaultRequestCriteria(criteria, payload);
    }
    return {
      ...criteria,
      criteria: criteria.criteria.map(
        (criterion) => {
          var _a2;
          return !this.hasLanguageCriteria((_a2 = criterion.language) == null ? void 0 : _a2.ids) ? set(criterion, "language.ids[0]", this.mapLocaleToId(payload)) : criterion;
        }
      )
    };
  }
  mapLocaleToId(payload) {
    var _a2;
    const languageCode = getLanguage(payload.language, this.defaultLanguage, this.options);
    const languageList = this.getBasicLanguageListData(payload);
    const selectedLanguageCode = languageList == null ? void 0 : languageList.find((lang) => lang.code === languageCode);
    return (_a2 = selectedLanguageCode == null ? void 0 : selectedLanguageCode.id) != null ? _a2 : this.defaultLanguageId;
  }
  hasLanguageCriteria(languageIds) {
    return languageIds ? languageIds.length > 0 : false;
  }
  getNewsArticleSearchByTextDefaultRequestCriteria(criteria, payload) {
    const langId = this.mapLocaleToId(payload);
    return {
      ...criteria,
      criteria: [
        {
          language: {
            ids: [langId]
          }
        }
      ]
    };
  }
  getNewsListByMediaKindRequest(criteria, payload) {
    var _a2;
    return {
      data: this.getNewsListByMediaKindRequestCriteria(criteria, payload),
      meta: {
        pagination: {
          limit: payload.itemsPerPage,
          cursor: (_a2 = payload.activePageCursor) != null ? _a2 : void 0
        }
      }
    };
  }
  getNewsListByMediaKindRequestCriteria(criteria, payload) {
    var _a2, _b2;
    const langId = this.mapLocaleToId(payload);
    return !this.hasLanguageCriteria((_b2 = (_a2 = criteria.filter) == null ? void 0 : _a2.language) == null ? void 0 : _b2.ids) ? set(criteria, "filter.language.ids[0]", langId) : criteria;
  }
  getNewsArticleSearchByTextResponse(criteria, payload) {
    const request = this.getNewsArticleSearchByTextRequest(criteria, payload);
    const response = this.getEndpoints().newsArticleSearchByText.getData(request);
    return response != null ? response : null;
  }
  getNewsArticleSearchByTextData(criteria, payload) {
    var _a2;
    const response = this.getNewsArticleSearchByTextResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getNewsArticleSearchByTextMeta(criteria, payload) {
    var _a2;
    const response = this.getNewsArticleSearchByTextResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.meta) != null ? _a2 : null;
  }
  getNewsArticleSearchByTextSubscriptionResponse(criteria, payload) {
    const request = this.getNewsArticleSearchByTextRequest(criteria, payload);
    const response = this.getEndpoints().newsArticleSearchByTextSubscription.getData(request);
    return response != null ? response : null;
  }
  getNewsArticleSearchByTextSubscriptionData(criteria, payload) {
    var _a2;
    const response = this.getNewsArticleSearchByTextSubscriptionResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getNewsArticleSearchByTextSubscriptionMeta(criteria, payload) {
    var _a2;
    const response = this.getNewsArticleSearchByTextSubscriptionResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.meta) != null ? _a2 : null;
  }
  getNewsListByMediaKindResponse(criteria, payload) {
    const request = this.getNewsListByMediaKindRequest(criteria, payload);
    const response = this.getEndpoints().newsListByMediaKind.getData(request);
    return response != null ? response : null;
  }
  getNewsListByMediaKindData(criteria, payload) {
    var _a2;
    const response = this.getNewsListByMediaKindResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getNewsListByMediaKindMeta(criteria, payload) {
    var _a2;
    const newsListByMediaKind = this.getNewsListByMediaKindResponse(criteria, payload);
    return (_a2 = newsListByMediaKind == null ? void 0 : newsListByMediaKind.meta) != null ? _a2 : null;
  }
  getNewsListByMediaKindSubscriptionResponse(criteria, payload) {
    const request = this.getNewsListByMediaKindRequest(criteria, payload);
    const response = this.getEndpoints().newsListByMediaKindSubscription.getData(request);
    return response != null ? response : null;
  }
  getNewsListByMediaKindSubscriptionData(criteria, payload) {
    var _a2;
    const response = this.getNewsListByMediaKindSubscriptionResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  getNewsListByMediaKindSubscriptionMeta(criteria, payload) {
    var _a2;
    const response = this.getNewsListByMediaKindSubscriptionResponse(criteria, payload);
    return (_a2 = response == null ? void 0 : response.meta) != null ? _a2 : null;
  }
  getNewsArticleGetRequest(newsArticleCode) {
    return { code: newsArticleCode, includeMedia: true };
  }
  async getNewsArticleSearchByTextSubscriptionObservable(criteria, payload) {
    try {
      const request = this.getNewsArticleSearchByTextRequest(criteria, payload);
      await this.getEndpoints().newsArticleSearchByTextSubscription.fetchObservable(request);
      return this.getEndpoints().newsArticleSearchByTextSubscription.getObservable(request);
    } catch (error) {
      this.logger.error(error);
      return Promise.reject(error);
    }
  }
  async getNewsListByMediaKindObservable(criteria, payload) {
    try {
      const newsListByMediaKindRequest = this.getNewsListByMediaKindRequest(criteria, payload);
      await this.getEndpoints().newsListByMediaKindSubscription.fetchObservable(newsListByMediaKindRequest);
      return this.getEndpoints().newsListByMediaKindSubscription.getObservable(newsListByMediaKindRequest);
    } catch (error) {
      this.logger.error(error);
      return Promise.reject(error);
    }
  }
  async updateNewsArticleSearchByText(criteria, payload) {
    try {
      const request = this.getNewsArticleSearchByTextRequest(criteria, payload);
      return this.getEndpoints().newsArticleSearchByText.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateNewsListByMediaKind(criteria, payload) {
    try {
      const newsListByMediaKindRequest = this.getNewsListByMediaKindRequest(criteria, payload);
      return this.getEndpoints().newsListByMediaKind.updateState(newsListByMediaKindRequest);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async updateNewsArticleGet(payload, newsArticle) {
    try {
      const code = this.getNewsArticleCode(newsArticle);
      const request = this.getNewsArticleGetRequest(code);
      return this.getEndpoints().newsArticleGet.updateState(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async removeNewsArticleSearchByTextSubscription(criteria, payload) {
    try {
      const request = this.getNewsArticleSearchByTextRequest(criteria, payload);
      return this.getEndpoints().newsArticleSearchByTextSubscription.removeSubscriptionIfInactive(request);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  async removeNewsListByMediaKindSubscription(criteria, payload) {
    try {
      const newsListRequest = this.getNewsListByMediaKindRequest(criteria, payload);
      return this.getEndpoints().newsListByMediaKindSubscription.removeSubscriptionIfInactive(newsListRequest);
    } catch (error) {
      this.logger.error(error);
      return false;
    }
  }
  getBasicLanguageListRequest() {
    return {};
  }
  getBasicLanguageListData(payload) {
    var _a2;
    const request = this.getBasicLanguageListRequest();
    const response = this.getEndpoints().basicLanguageList.getData(request);
    return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
  }
  async updateBasicLanguageList(payload) {
    const request = this.getBasicLanguageListRequest();
    return this.getEndpoints().basicLanguageList.updateState(request);
  }
}

export { NewsListStoreModuleFactory };
